// extracted by mini-css-extract-plugin
module.exports = {"scrollTable":"ScrollTable__scrollTable__1Rxda","left":"ScrollTable__left__3q8lK","right":"ScrollTable__right__fTmdH","label":"ScrollTable__label__20I4n"};